import { memo, useEffect, useState } from 'react'

import { FileItem } from '@inno-sdks/files'
import { useGetFileItem } from 'modules/desktop/modules/files-integration/api/hooks/useGetFileItem'

import { useItemModal } from '../../../hooks/useItemModal'
import styles from './HtmlPreview.module.scss'

export const HtmlPreview = memo(() => {
  const { itemId } = useItemModal()
  const { data: item } = useGetFileItem<FileItem>(itemId)

  const [content, setContent] = useState<string>()
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    if (!item?.metaData.presignedUrl) {
      return
    }

    const abortController = new AbortController()

    fetch(item.metaData.presignedUrl, {
      signal: abortController.signal
    })
      .then(res => res.text())
      .then(setContent)
      .catch(() => {})
      .finally(() => setIsLoading(false))

    return () => abortController.abort()
  }, [item?.metaData.presignedUrl])

  if (isLoading) {
    return <div className={styles.loadingContainer}>Loading...</div>
  }

  if (!content) {
    return null
  }

  return (
    <div className={styles.container}>
      <iframe sandbox='' srcDoc={content} className={styles.iframe} />
    </div>
  )
})
